import Swiper from "swiper"

import updateArrowPosition from "../../common/components/updateArrowPosition"
import {isFunction} from "../../common/components/function"


export default function SwiperCom(app, context) {

    // Make sure the context is set
    if(!context) context = document

    // UX:
    const configCommon = {
        freeMode: false,
        freeModeMomentum: false,
        freeModeMomentumRatio: 0.5,
        freeModeMomentumVelocityRatio: 0.5,
        freeModeMinimumVelocity: 1,
        longSwipes: false,
    }

    // Configs
    const configSpecific = {
        "template-dont-use": function(){
            // ...

            return {
                breakpoints: {
                    768: { // min tablet
                        // ...
                    },
                    992: { // min desktop small
                        // ...
                    },
                    1260: { // min desktop large
                        // ...
                    }
                }
            }
        },

        // Website instances:

        "generic": {
            autoHeight: true,
            slidesPerView: 1,
            loop: true
        },

        "order": {
            slidesPerView: 'auto',
            centeredSlides: true,
            autoHeight: false,
            spaceBetween: 16,
            loop: false,
            breakpoints: {
                768: {
                    spaceBetween: 10,
                    noSwiping: true
                },
                1024: {
                    centeredSlides: false,
                    spaceBetween: 10,
                    slidesPerView: 5,
                    noSwiping: true
                },
                1366: {
                    centeredSlides: false,
                    spaceBetween: 13,
                    slidesPerView: 5,
                    noSwiping: true
                }
            },
            on: {
                init: function()
                {

                    // Prepare the active slide id
                    const activeSlideId = `${window.current_service}-${window.current_category}`

                    // Get the slides list
                    const slides = [...this.$wrapperEl[0].children]

                    // Get the current slide
                    const current = slides.find((el)=> { return el.getAttribute('data-id') === activeSlideId})

                    // Get the current slide index
                    const index = slides.indexOf(current)

                    // Center teh slide
                    this.slideTo(index)

                    // If desktop
                    if(window.innerWidth >= 1024) updateArrowPosition(index)

                }
            }
        },

        "locations": {
            slidesPerView: 1,
            autoHeight: true,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 100,
                    autoHeight: false,
                    noSwiping: true,
                    loop: false
                }
            }
        },

        "services": {
            slidesPerView: 'auto',
            autoHeight: false,
            autoplay: {
                delay: 5000
            },
            loop: true
        },

        "price": {
            autoHeight: true,
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            breakpoints: {
                // Min tablet
                768: {
                    centeredSlides: false,
                    slidesPerView: 'auto',
                    spaceBetween: 27
                },
                // Min desktop small
                992: {
                    centeredSlides: false,
                    slidesPerView: 'auto',
                    spaceBetween: 27
                },
                // Min desktop large
                1260: {
                    centeredSlides: false,
                    slidesPerView: 'auto',
                    spaceBetween: 35
                },
                // Min desktop wide
                1600: {
                    centeredSlides: false,
                    slidesPerView: 'auto',
                    spaceBetween: 41
                }
            },
            navigation: { // custom nav
                nextEl: '.outer-swiper-nav .swiper-button-next',
                prevEl: '.outer-swiper-nav .swiper-button-prev',
            }
        },

        // Panel instances:

        "inner-page-nav": {
            slidesPerView: 'auto',
            on: {
                init: function () {
                    const slides = [...this.$wrapperEl[0].children]
                    const current = slides.find((el)=> { return el.classList.contains('active') })
                    const index = slides.indexOf(current)
                    this.slideTo(index)
                }
            }
        },

        "links-and-coupons": {
            spaceBetween: 30
        },

        "widget-generic": {
            observer: true,
            observeParents: true,
        },

        "manage-subscription": {
            observer: true,
            observeParents: true,
            slidesPerView: 'auto',
            centeredSlides: false,
            slideToClickedSlide: true,
            breakpoints: {
                // Min tablet
                768: {
                    allowTouchMove: false,
                }
            }
        },

        "faq": {
            slidesPerView: 'auto',
            slideToClickedSlide: true,
        }

        // Add more configs here
    }

    let swipers = context.querySelectorAll(".swiper-container")

    for (let i = 0; i < swipers.length; i++) {

        let thisSwiper = swipers[i]
        let configType = thisSwiper.dataset.config
        let instanceClass = `instance-${i}`
        let instanceConfig = isFunction(configSpecific[configType]) ? configSpecific[configType]() : configSpecific[configType]
        let config = Object.assign({}, configCommon, {
            navigation: {
                nextEl: `.${instanceClass} .swiper-button-next`,
                prevEl: `.${instanceClass} .swiper-button-prev`,
            },
            pagination: {
                el: `.${instanceClass} .swiper-pagination`,
                clickable: true,
                dynamicBullets: true,
            }
        }, instanceConfig)

        thisSwiper.classList.add(instanceClass)
        new Swiper(`.${instanceClass}.swiper-container`, config)

    }

}
